import { MenuItem, Select, SelectProps } from "@mui/material";
import { ScvAutonomyAuxControlAction } from "protos/atk/enums";
import { useTranslation } from "react-i18next";
import React from "react";

export const ScvAuxControlSelect: React.FC<SelectProps> = (props) => {
  const { t } = useTranslation();

  return (
    <Select {...props}>
      <MenuItem value={ScvAutonomyAuxControlAction.AUX_CONTROL_ACTION_NONE}>
        {t("views.autotractor.autonomousActivities.auxControlAction.none")}
      </MenuItem>
      <MenuItem
        value={ScvAutonomyAuxControlAction.AUX_CONTROL_ACTION_DETENT_UP}
      >
        {t("views.autotractor.autonomousActivities.auxControlAction.detentUp")}
      </MenuItem>
      <MenuItem
        value={ScvAutonomyAuxControlAction.AUX_CONTROL_ACTION_DETENT_DOWN}
      >
        {t(
          "views.autotractor.autonomousActivities.auxControlAction.detentDown"
        )}
      </MenuItem>
      <MenuItem value={ScvAutonomyAuxControlAction.AUX_CONTROL_ACTION_FLOAT}>
        {t("views.autotractor.autonomousActivities.auxControlAction.float")}
      </MenuItem>
    </Select>
  );
};
